import {
  CircularProgress,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  Button,
  Dialog,
  DialogTitle,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import queryString from 'query-string';
import { Link, useLocation } from 'react-router-dom';
import { numberWithCommas, removeEmptyValueObject } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';
import List from './components/ticketList';
import handleError from '../../utils/handleError';
import CounterCard from '../../components/Cards/counterCard';
import { getAllTicket, getStatusCounts } from '../../api/ticket/get';
import CreateTicket from './components/registerTicket';
import RenderFilters from '../../utils/listDaynamicFilter';
import Filter from '../../utils/filter';
import RonadIcons from '../../components/iconComponent';

const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    mainContainer: {
      backgroundColor: "#fff",
      padding: "24px",
      borderRadius: "4px"
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      cursor: "pointer"
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-40px',
      display: 'flex',
      textAlign: 'center',
      paddingBottom: "12px !important"
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
    icon: {
      backgroundColor: "#f5f5f5",
      padding: "10px"
    }
  })
);

const sum = (arr: number[]) => {
  return arr.reduce((acc, current) => {
    if(current && current > 0) {
      return acc + current
    }else {
      return acc
    }
  }, 0)
}

const SUPPORT_PENDING = ['FFC_PENDING','SUPPORT_PENDING', 'SUPPORT_OWNER_ANSWERED', 'PARTNER_ASSIGNEE_ANSWERED', 'FFC_OWNER_ANSWERED']
const SUPPORT_ASSIGNEE_ANSWERED = ['SUPPORT_ASSIGNEE_ANSWERED', 'FFC_ASSIGNEE_ANSWERED']
const SUPPORT_OPEN = 'SUPPORT_OPEN'
const PARTNER_OWNER_ANSWERED = ['PARTNER_PENDING','PARTNER_OPEN', 'PARTNER_OWNER_ANSWERED']
const CLOSED = ['SUPPORT_CLOSED', 'PARTNER_CLOSED', 'FFC_CLOSED']

const Tickets = props => {
  const { search } = useLocation();
  const classes = useStyles();
  const filters: Filter[] = [
    {
      type: 'input',
      id: 'tracking',
      label: 'شماره تیکت'
    },
    {
      type: 'input',
      id: 'title.substring',
      label: 'کلمه کلیدی عنوان',
    },
    // {
    //   type: 'checkbox',
    //   id: 'status.in',
    //   label: 'وضعیت',
    //   data: ['OWNER_ANSWERED', 'OPEN', 'PENDING', 'ASSIGNEE_ANSWERED', 'CLOSED'],
    //   translateType: 'ticket'
    // },
    // {
    //   type: 'checkbox',
    //   id: 'priority.in',
    //   label: 'الویت',
    //   data: ['LOW','NORMAL','HIGH','CRITICAL'],
    //   translateType: 'ticket'
    // },
    {
      type: 'date-picker',
      id: 'createdAt.gte',
      label: 'تاریخ ایجاد'
    },
    {
      type: 'date-picker',
      id: 'updatedAt.gte',
      label: 'تاریخ ویرایش'
    },
    {
      type: 'input',
      id: 'subjectId',
      label: 'موضوع'
    },
  ]
  const [isOpenFilter, setIsOpenFilter] = useState(false)
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    ...queryString.parse(search)
  });
  const [ticketCounts, setTicketCounts] = useState(0)
  const [openSize, setOpenSize] = React.useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [openMsg, setOpenMsg] = useState(false);
  const [loading, setLoading] = useState(true);
  const [finalizedTicketsList, setFinalTickets] = useState<any>([]);

  useEffect(() => {
    getTickets();
    getingTicketCount(request);
  }, [filtersValues]);

  const checkActiveCard = name => {
    switch (name) {
      case 'SUPPORT_OPEN':
        return filtersValues['advanceItem.in'] === SUPPORT_OPEN;
      case 'SUPPORT_PENDING':
        return filtersValues['advanceItem.in'] === SUPPORT_PENDING.join(',');
      case 'SUPPORT_ASSIGNEE_ANSWERED':
        return filtersValues['advanceItem.in'] === SUPPORT_ASSIGNEE_ANSWERED.join(',');
      case 'PARTNER_OWNER_ANSWERED':
        return filtersValues['advanceItem.in'] === PARTNER_OWNER_ANSWERED.join(',');
      case 'CLOSED':
        return filtersValues['advanceItem.in'] === CLOSED.join(',');
    }
  };

  const handleCardClose = () => {
    const newFilterValues = { ...filtersValues };
    delete newFilterValues['advanceItem.in'];
    delete newFilterValues['assignmentType'];
    setFiltersValues({
      ...removeEmptyValueObject(newFilterValues),
      page: 0,
      size: 10,
    });
  };

  const handleCardClick = name => {
    switch (name) {
      case 'SUPPORT_OPEN':
        setFiltersValues({
          'advanceItem.in': SUPPORT_OPEN,
          page: 0,
          size: 10,
        });
        break;
      case 'SUPPORT_PENDING':
        setFiltersValues({
          'advanceItem.in': SUPPORT_PENDING,
          page: 0,
          size: 10,
        });
        break;
      case 'SUPPORT_ASSIGNEE_ANSWERED':
        setFiltersValues({
          'advanceItem.in': SUPPORT_ASSIGNEE_ANSWERED,
          page: 0,
          size: 10,
        });
        break;
      case 'PARTNER_OWNER_ANSWERED':
        setFiltersValues({
          'advanceItem.in': PARTNER_OWNER_ANSWERED,
          assignmentType: 'PARTNER', 
          page: 0,
          size: 10,
        });
        break;
      case 'CLOSED':
        setFiltersValues({
          'advanceItem.in': CLOSED,
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const getTickets = async () => {
    try {
      const res = await getAllTicket(filtersValues)
      setFinalTickets(res.data.content)
      setTicketCounts(res.data.totalCount)
    } catch (error) {
      handleError(error)  
    }
  };

  const getingTicketCount = async (actions: any) => {
    try {
      setLoading(true);
      const counts = await getStatusCounts()
      setCardCounts(counts.data);
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      'status': 'OPEN',
    },
    closeCount: {
      'status': 'CLOSED',
    },
    answeredCount: {
      'status': 'ATTENDEE_ANSWERED',
    },
    ownerAnsweredCount: {
      'status': 'OWNER_ANSWERED',
    },
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleCloseModal = () => {
    setOpenMsg(false);
  };

  return (
    <React.Fragment>
      <p className='typography-cards'>
        پشتیبانی
      </p>
      <div className={classes.mainContainer}>
        <Grid container spacing={2} style={{marginBottom: "24px"}}>
          <Grid item md={6} lg xs={12}>
            <CounterCard
              isActive={checkActiveCard('SUPPORT_OPEN')}
              data={numberWithCommas(cardCounts.SUPPORT_OPEN || 0)}
              handleClick={() => handleCardClick('SUPPORT_OPEN')}
              label="ایجاد شده"
              icon="mailUnread"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg xs={12}>
            <CounterCard
              isActive={checkActiveCard('SUPPORT_PENDING')}
              data={numberWithCommas(sum([
                cardCounts?.SUPPORT_PENDING, 
                cardCounts?.SUPPORT_OWNER_ANSWERED,
                cardCounts?.FFC_OWNER_ANSWERED,
                cardCounts?.FFC_PENDING,
                cardCounts?.PARTNER_ASSIGNEE_ANSWERED,
              ]) || 0)}
              handleClick={() => handleCardClick('SUPPORT_PENDING')}
              label="درحال بررسی"
              icon="mailOpen"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg xs={12}>
            <CounterCard
              isActive={checkActiveCard('SUPPORT_ASSIGNEE_ANSWERED')}
              data={numberWithCommas(sum([
                cardCounts.SUPPORT_ASSIGNEE_ANSWERED,
                cardCounts.FFC_ASSIGNEE_ANSWERED,
              ]) || 0)}
              handleClick={() => handleCardClick('SUPPORT_ASSIGNEE_ANSWERED')}
              label="پاسخ داده شده"
              icon="mailAnswered"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg xs={12}>
            <CounterCard
              isActive={checkActiveCard('PARTNER_OWNER_ANSWERED')}
              data={numberWithCommas(sum([
                cardCounts.PARTNER_OWNER_ANSWERED,
                cardCounts.PARTNER_OPEN,
                cardCounts.PARTNER_PENDING,
              ]) || 0)}
              handleClick={() => handleCardClick('PARTNER_OWNER_ANSWERED')}
              label="نیازمند بررسی"
              icon="mailOutline"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
          <Grid item md={6} lg xs={12}>
            <CounterCard
              isActive={checkActiveCard('CLOSED')}
              data={numberWithCommas(sum([
                cardCounts.PARTNER_CLOSED,
                cardCounts.SUPPORT_CLOSED,
                cardCounts.FFC_CLOSED,
              ]) || 0)}
              handleClick={() => handleCardClick('CLOSED')}
              label="بسته شده"
              icon="mailOutline"
              iconColor="#2f4858"
              color="#f5f5f5"
              dActiveCard={handleCardClose}
            />
          </Grid>
        </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            style={{marginBottom: "24px"}}
          >
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '8px' }}
                onClick={() => setOpenMsg(true)}
              >
                {`ایجاد تیکت`}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{ marginRight: '8px' }}
                onClick={() =>
                  setIsOpenFilter(prev => !prev)
                }
                endIcon={
                  <RonadIcons name='magnifier' size={0.7} className='text-white'/>
                }
              >{`جستجو`}</Button>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item md={12}>
              <Filter
                isOpenFilters={isOpenFilter}
                setIsOpenFilter={setIsOpenFilter}
                filters={filters}
                onFilter={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    page: 0,
                    size: 10,
                  });
                }}
                mainFiltersCount={0}
                baseFilter={{
                  type: 'input',
                  id: 'trackingCode.contains',
                  placeholder: 'کد پیگیری',
                }}
                filterValues={filtersValues} />
            </Grid>
          </Grid>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {finalizedTicketsList?.length > 0 ? (
                <List
                  data={
                    finalizedTicketsList
                  }
                />
              ) : (
                <Typography variant="h3" component="div">
                  تیکت موجود نیست
                </Typography>
              )}
            </>
          )}
          <Grid item xs={12} sm={12} style={{ marginTop: '24px' }}>
            {finalizedTicketsList?.length > 0 && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <FormControl
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                    {' '}
                    تعداد نمایش در هر صفحه:
                  </div>
                  <Select
                    open={openSize}
                    onClose={handleClose}
                    onOpen={() => setOpenSize(true)}
                    value={filtersValues.size}
                    onChange={handleChangeSizePage}
                  >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </FormControl>
                <Pagination
                  count={Math.ceil(
                    ticketCounts / filtersValues.size
                  )}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </Grid>
      </div>
      <Dialog
        open={openMsg}
        onClose={handleCloseModal}
        aria-labelledby="responsive-dialog-title"
        maxWidth="sm"
        fullWidth
        style={{ padding: '16px' }}
      >
        <DialogTitle>
          <Grid container justifyContent="center" justify="center">
            <p style={{ marginTop: '-8px' }}>ایجاد تیکت جدید</p>
          </Grid>
        </DialogTitle>

        <Grid container direction="column">
          <CreateTicket handleCloseModal={handleCloseModal} getTickets={getTickets}/>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default Tickets;
